import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const LINKEDIN_URL = "https://www.linkedin.com/in/jacob-haas-78710a252";
const EMAIL = "jacobhaas03@gmail.com";

const ConnectTree = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        onClick={() => setOpen((v) => !v)}
        className="text-sm font-semibold text-foreground transition-colors hover:text-primary leading-5"
      >
        Let's connect.
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.18 }}
            className="absolute left-full top-0 flex items-center gap-1 z-10 ml-2"
            style={{ height: "20px" }}
          >
            {/* Right-facing curly brace centered to the two links */}
            <svg width="8" height="30" viewBox="0 0 8 30" fill="none" className="text-muted-foreground/40 shrink-0" style={{ marginTop: "5px" }}>
              <path
                d="M8 1 Q3 1 3 8 Q3 13 0 15 Q3 17 3 22 Q3 29 8 29"
                stroke="currentColor"
                strokeWidth="1.2"
                fill="none"
              />
            </svg>

            <div className="flex flex-col" style={{ marginTop: "5px" }}>
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-muted-foreground transition-colors hover:text-foreground whitespace-nowrap leading-[18px]"
              >
                LinkedIn
              </a>
              <a
                href={`mailto:${EMAIL}`}
                className="text-sm text-muted-foreground transition-colors hover:text-foreground whitespace-nowrap leading-[18px]"
              >
                Mail
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ConnectTree;
